import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles/theme";

const Footer: React.FC = () => (
  <FooterContainer>
    <span>
      <FooterLink href="/terms">利用規約</FooterLink>
      <FooterLink href="/guideline">ガイドライン</FooterLink>
    </span>
  </FooterContainer>
);

const FooterContainer = styled.footer`
  text-align: center;
  padding: 10px;
  position: fixed;
  inset: auto 16px 0 auto;
  z-index: 100;
  @media (max-width: ${breakpoints.mobile}) {
    display: none; // スマホでは非表示
  }
`;

const FooterLink = styled.a`
  color: #888;
  margin: 0 10px;
  font-size: 1rem;
  text-decoration: none;
`;

export default Footer;
